import { ServerStatus } from "../../../interface";
import { Gamecloud } from "../../../gamecloud";

const BASE_SELECTOR: string = "[data-server-state]";
const CHECKBOX_SELECTOR: string = ".fancy-checkbox";
const INSTALLING_SELECTOR: string = ".installing";

export class GameserverStateUI extends Gamecloud {
  public constructor(private $base: JQuery) {
    super();
  }

  public onRestartClick(callback: (event? : JQuery.TriggeredEvent) => {}) {
    this.$base.find("[data-restart]").on('click', (event? : JQuery.TriggeredEvent) => {
      callback(event);
    });
  }

  public updateUI(state: number) {
    switch(state) {
      case ServerStatus.Install:
        this.disableSwitch();
        this.setCheckbox(false);
        this.disableReinstallServer(true);
        this.disableRestart();
        this.loader.enable();
        this.$base.find(CHECKBOX_SELECTOR).addClass('is-loading');
        this.$base.find(CHECKBOX_SELECTOR + ' [data-label]').text('Installing');
        break;
      case ServerStatus.Loading:
        this.disableSwitch();
        this.setCheckbox(false);
        this.loader.enable();
        this.disableRestart();
        this.disableReinstallServer(true);
        this.$base.find(CHECKBOX_SELECTOR).addClass('is-loading');
        this.$base.find(CHECKBOX_SELECTOR + ' [data-label]').text('Loading');
        break;
      case ServerStatus.Maintenance:
        this.disableSwitch();
        this.setCheckbox(false);
        this.loader.enable();
        this.disableRestart();
        this.disableReinstallServer(true);
        this.$base.find(CHECKBOX_SELECTOR).addClass('is-loading');
        this.$base.find(CHECKBOX_SELECTOR + ' [data-label]').text('Maintenance');
        break;
      case ServerStatus.PreInstall:
        this.disableSwitch();
        this.setCheckbox(false);
        this.disableRestart();
        this.loader.enable();
        this.disableReinstallServer(true);
        this.$base.find(CHECKBOX_SELECTOR).addClass('is-loading');
        this.$base.find(CHECKBOX_SELECTOR + ' [data-label]').text('Pre Install');
        break;
      case ServerStatus.Removing:
        this.disableSwitch();
        this.setCheckbox(false);
        this.loader.enable();
        this.disableRestart();
        this.disableReinstallServer(true);
        this.$base.find(CHECKBOX_SELECTOR).addClass('is-loading');
        this.$base.find(CHECKBOX_SELECTOR + ' [data-label]').text('Removing');
        break;
      case ServerStatus.Running:
        this.enableSwitch();
        this.enableRestart();
        this.setCheckbox(true);
        this.loader.disable();
        this.disableReinstallServer(false);
        this.$base.find(CHECKBOX_SELECTOR).removeClass('is-loading');
        this.$base.find(CHECKBOX_SELECTOR + ' [data-label]').text('Online');
        break;
      case ServerStatus.Starting:
        this.disableSwitch();
        this.setCheckbox(true);
        this.disableRestart();
        this.loader.enable();
        this.disableReinstallServer(true);
        this.$base.find(CHECKBOX_SELECTOR).addClass('is-loading');
        this.$base.find(CHECKBOX_SELECTOR + ' [data-label]').text('Starting');
        break;
      case ServerStatus.Stopped:
        this.enableSwitch();
        this.setCheckbox(false);
        this.disableRestart();
        this.loader.disable();
        this.disableReinstallServer(false);
        this.$base.find(CHECKBOX_SELECTOR).removeClass('is-loading');
        this.$base.find(CHECKBOX_SELECTOR + ' [data-label]').text('Offline');
        break;
      case ServerStatus.Stopping:
        this.disableSwitch();
        this.setCheckbox(false);
        this.disableRestart();
        this.loader.enable();
        this.disableReinstallServer(true);
        this.$base.find(CHECKBOX_SELECTOR).removeClass('is-loading');
        this.$base.find(CHECKBOX_SELECTOR + ' [data-label]').text('Stopping');
        break;
      case ServerStatus.Suspended:
        this.disableSwitch();
        this.setCheckbox(false);
        this.loader.enable();
        this.disableRestart();
        this.disableReinstallServer(true);
        this.$base.find(CHECKBOX_SELECTOR).removeClass('is-loading');
        this.$base.find(CHECKBOX_SELECTOR + ' [data-label]').text('Suspended');
        break;
      case ServerStatus.Unknown:
        this.enableSwitch();
        this.setCheckbox(false);
        this.loader.enable();
        this.disableRestart();
        this.disableReinstallServer(true);
        this.$base.find(CHECKBOX_SELECTOR).removeClass('is-loading');
        this.$base.find(CHECKBOX_SELECTOR + ' [data-label]').text('Unknown');
        break;
      case ServerStatus.Updating:
        this.disableSwitch();
        this.setCheckbox(false);
        this.loader.enable();
        this.disableRestart();
        this.disableReinstallServer(true);
        this.$base.find(CHECKBOX_SELECTOR).removeClass('is-loading');
        this.$base.find(CHECKBOX_SELECTOR + ' [data-label]').text('Updating');
        break;
    }
  }

  public setCheckbox(state: boolean) {
    if (state) {
      let index = this.$base.find("[data-index]").data("index");
      window.checkboxes[index].setActive();
      // this.$base.find(CHECKBOX_SELECTOR).addClass('is-active');
    } else {
      let index = this.$base.find("[data-index]").data("index");
      window.checkboxes[index].setInactive();
      // this.$base.find(CHECKBOX_SELECTOR).removeClass('is-active');
    }
  }

  public enableRestart() {
    $('[data-server-state]').find('button').removeAttr('disabled');
  }

  public disableRestart() {
    $('[data-server-state]').find('button').attr('disabled', 'disabled');
  }

  public disableReinstallServer(state: boolean) {
    if (state) {
      $('[data-reinstall]').attr('disabled', 'disabled');
    } else {
      $('[data-reinstall]').removeAttr('disabled');
    }
  }

  public disableSwitch() {
    this.$base.find('.disable-fancy-checkbox ').addClass("is-visible");
  }

  public enableSwitch() {
    this.$base.find('.disable-fancy-checkbox ').removeClass("is-visible");
  }

  public getRestartURL() {
    return this.$base.data('server-links').restart;
  }

  public getStartURL() {
    return this.$base.data('server-links').start;
  }

  public getStopURL() {
    return this.$base.data('server-links').stop;
  }

  public onSelectChange(callback: () => {}) {
    this.$base.find(CHECKBOX_SELECTOR).find('.fancy-checkbox__switch').on('click', () => {
      callback();
    });
  }

  public isChecked() {
    return this.$base.find(CHECKBOX_SELECTOR).hasClass('is-active');
  }

  public showInstalling(details) {
    const installing = $('.server__cover').find(INSTALLING_SELECTOR);
    if (typeof details !== 'undefined' && details) {
      installing.addClass('is-visible');
      installing.find('.installing__progress span').css('width', details.percentage + '%');
    } else {
      installing.removeClass('is-visible');
    }
  }
}

export function createGameserverStateUIInstances() : GameserverStateUI[] {
  const instances: GameserverStateUI[] = [];

  $(BASE_SELECTOR).each((i, el) => {
    instances.push(new GameserverStateUI($(el)));
  });

  return instances;
}
